import { render, staticRenderFns } from "./Request.vue?vue&type=template&id=85391e20&scoped=true"
import script from "./Request.vue?vue&type=script&lang=js"
export * from "./Request.vue?vue&type=script&lang=js"
import style0 from "./Request.vue?vue&type=style&index=0&id=85391e20&prod&scoped=true&lang=css"
import style1 from "./Request.vue?vue&type=style&index=1&id=85391e20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85391e20",
  null
  
)

export default component.exports